export default {
  createNewAccount: "צור חשבון חדש",
  alreadyAccount: "?יש לך כבר חשבון",
  signInstead: "היכנס במקום זאת",
  successFullyRegister: "נרשמת בהצלחה לבינה"
}